module.exports = __webpack_public_path__ + "static/media/me_vip_level_0.cb68f839.png";